import { render, staticRenderFns } from "./ListActivitiesMatter.vue?vue&type=template&id=6e5856b8"
import script from "./ListActivitiesMatter.vue?vue&type=script&lang=js"
export * from "./ListActivitiesMatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports